module.exports = __webpack_public_path__ + "static/img/img-tracking-man.1341f60.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/img-tracking-man.png
// module id = UZAv
// module chunks = 134